import { styled } from '@mui/material';
import { Loader } from '#components/Loader/index.tsx';

const Container = styled('div')(() => ({
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  left: 0,
  position: 'fixed',
  right: 0,
  top: 0,
  zIndex: 1400,
}));

export const LinkLoading = () => {
  return (
    <Container>
      <Loader />
    </Container>
  );
};
